import script from "./ArtifiFallbackPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtifiFallbackPreview.vue?vue&type=script&setup=true&lang=js"

import "./ArtifiFallbackPreview.vue?vue&type=style&index=0&id=6ac21aae&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac21aae"]])

export default __exports__